import React from 'react';
import { Row, Col } from 'react-bootstrap';

function TodayAttendanceAbsences({ title = '', onRequest = false }) {
  return (
    <>
      {!onRequest && (
        <>
          <Row style={{ paddingRight: 5, paddingLeft: 5, height: 85 }}>
            <Col xs={12} md={6} xl={6}>
              <div>
                <p className="alert-p" style={{ marginBottom: '3px', fontSize: '10px' }}>
                  <span
                    style={{
                      backgroundColor: '#17A2B8',
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      verticalAlign: 'middle',
                      borderRadius: 0
                    }}
                  />{' '}
                  {title.vacations} Vacaciones
                </p>
                <p className="alert-p" style={{ marginBottom: '3px', fontSize: '10px' }}>
                  <span
                    style={{
                      backgroundColor: '#FB7474',
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      verticalAlign: 'middle',
                      borderRadius: 0
                    }}
                  />{' '}
                  {title.permissions} Permisos
                </p>
                <p className="alert-p" style={{ marginBottom: '3px', fontSize: '10px' }}>
                  <span
                    style={{
                      backgroundColor: '#674ea7',
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      verticalAlign: 'middle',
                      borderRadius: 0
                    }}
                  />{' '}
                  {title.administrative} Días Adm.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} xl={6}>
              <div>
                <p className="alert-p" style={{ marginBottom: '3px', fontSize: '10px' }}>
                  <span
                    style={{
                      backgroundColor: '#29B48F',
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      verticalAlign: 'middle',
                      borderRadius: 0
                    }}
                  />{' '}
                  {title.licenses} Licencias
                </p>
                <p className="alert-p" style={{ marginBottom: '3px', fontSize: '10px' }}>
                  <span
                    style={{
                      backgroundColor: '#ff4707',
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      verticalAlign: 'middle',
                      borderRadius: 0
                    }}
                  />{' '}
                  {title.unjustified} Sin Marca
                </p>
                <p className="alert-p" style={{ marginBottom: '3px', fontSize: '10px' }}>
                  <span
                    style={{
                      backgroundColor: '#FFC107',
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      verticalAlign: 'middle',
                      borderRadius: 0
                    }}
                  />{' '}
                  {title.assistants} Asistentes
                </p>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default TodayAttendanceAbsences;
